import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8081/api/v1';

export interface Supplier {
    id: string;
    name: string;
    contactPerson?: string;
    phone?: string;
    email?: string;
    address?: string;
    notes?: string;
    isActive: boolean;
}

export interface SupplierCreateRequest {
    salonId: string;
    name: string;
    contactPerson?: string;
    phone?: string;
    email?: string;
    address?: string;
    notes?: string;
}

export interface SupplierUpdateRequest {
    name?: string;
    contactPerson?: string;
    phone?: string;
    email?: string;
    address?: string;
    notes?: string;
}

export const supplierApi = {
    /**
     * Get all suppliers for a salon
     */
    getSalonSuppliers: async (salonId: string): Promise<Supplier[]> => {
        const response = await axios.get(`${API_URL}/suppliers/salon/${salonId}`);
        return response.data;
    },

    /**
     * Get a supplier by ID
     */
    getSupplierById: async (id: string): Promise<Supplier> => {
        const response = await axios.get(`${API_URL}/suppliers/${id}`);
        return response.data;
    },

    /**
     * Create a new supplier
     */
    createSupplier: async (request: SupplierCreateRequest): Promise<Supplier> => {
        const response = await axios.post(`${API_URL}/suppliers`, request);
        return response.data;
    },

    /**
     * Update a supplier
     */
    updateSupplier: async (id: string, request: SupplierUpdateRequest): Promise<Supplier> => {
        const response = await axios.put(`${API_URL}/suppliers/${id}`, request);
        return response.data;
    },

    /**
     * Delete a supplier (soft delete)
     */
    deleteSupplier: async (id: string): Promise<void> => {
        await axios.delete(`${API_URL}/suppliers/${id}`);
    },

    /**
     * Search suppliers by name
     */
    searchSuppliers: async (salonId: string, query: string): Promise<Supplier[]> => {
        const response = await axios.get(`${API_URL}/suppliers/salon/${salonId}/search`, {
            params: { q: query }
        });
        return response.data;
    }
};

export default supplierApi;
